import type { CDNFile } from '@/utils/upload'
import { uniqueId } from 'lodash-es'
import { z } from 'zod'

export function generateUniID(prefix = 'jike-website-') {
	return uniqueId(prefix)
}

export enum AttachmentStatus {
	WAIT_TO_UPLOAD = 'WAIT_TO_UPLOAD',
	UPLOADING = 'UPLOADING',
	UPLOADED = 'UPLOADED',
	UPLOAD_FAILED = 'UPLOAD_FAILED',
}

export enum AttachmentType {
	PICTURE = 'PICTURE',
	VIDEO = 'VIDEO',
	LINK = 'LINK',
}

export const LinkInfoSchema = z.object({
	link: z.string(),
	linkUrl: z.string().url(),
	pictureUrl: z.string().url(),
	title: z.string(),
	type: z.string(),
})

export type LinkInfo = z.infer<typeof LinkInfoSchema>

export interface IAttachment {
	id: string
}

export interface FileAttachment extends IAttachment {
	type: AttachmentType.PICTURE | AttachmentType.VIDEO
	file: File
	cdn?: {
		file: CDNFile
	}
	status: AttachmentStatus
	metadata?: {
		width: number
		height: number
	}
}

export interface LinkAttachment extends IAttachment {
	type: AttachmentType.LINK
	linkInfo: LinkInfo
}

export type Attachment = FileAttachment | LinkAttachment
